document.addEventListener("DOMContentLoaded", function () {
	// Function to toggle the visibility of a form not  single license, qualification and skill are prefilled
	function toggleAddNewForm(containerSelector, addNewFormSelector) {
		const container = document.querySelector(containerSelector);
		const addNewForm = document.querySelector(addNewFormSelector);
		if (!container && addNewForm) {
			// If no prefilled items are found, show the "add new" form
			addNewForm.classList.remove("d-none");
		}
	}
	// Check if any items are prefilled and toggle visibility
	toggleAddNewForm(".drivers-license-wrap", ".form-element--drivers-license-add-new");
	toggleAddNewForm(".university-wrap", ".form-element--qualification-add-new");
	toggleAddNewForm(".skills-list-item", ".skills-list-add-new ");

	// function to toggle d-none class on click add new button
	function toggleForm(buttonSelector, formSelector) {
		const button = document.querySelector(buttonSelector);
		const form = document.querySelector(formSelector);
		if (button && form) {
			button.addEventListener("click", () => {
				if( buttonSelector == '.add-skills' ) { 
					if(document.getElementById("skillName")) {
						document.getElementById("skillName").value = '';
					}
				}
				form.classList.toggle("d-none")
			});
		}
	}

	// Toggle buttons for Add New License and Qualification
	toggleForm(".add-license", ".form-element--drivers-license-add-new");
	toggleForm(".add-qualification", ".form-element--qualification-add-new");
	toggleForm(".add-skills", ".skills-list-add-new");

	/* -- skills -- */
	function handleDeleteEntry(wrapperClass) {
		document.addEventListener("click", function (event) {
			const target = event.target.closest(".delete-file");
			if (target && target.closest(wrapperClass)) {
				target.closest(wrapperClass).remove();
			}
			if( wrapperClass === ".skills-list-item") {
				const remaining = document.querySelectorAll(wrapperClass);
				if (remaining.length === 0) {
					if(document.querySelector(".skills-list-add-new")) {
						// document.querySelector(".skills-list-add-new").classList.remove("d-none");
					}
				}
				
			}
		});
	}
	
	function handleAddEntry(formSelector, containerSelector, inputSelectors, templateCallback) {
		const form = document.querySelector(formSelector);
		const container = document.querySelector(containerSelector);
		const addButton = form?.querySelector(".add-btn");
	
		if (addButton && container) {
			addButton.addEventListener("click", function () {
				const values = inputSelectors.map((id) => {
					let inputValue = document.getElementById(id)?.value.trim();
					if ((id === "expiryDate" || id === "passedYear") && inputValue) {
						inputValue = inputValue.split("-")[0];
					}
					return inputValue;
				});
	
				if (values.some((value) => value === "")) {
					alert("Please fill in all required fields.");
					return;
				}
	
				const newEntry = document.createElement("div");
				newEntry.innerHTML = templateCallback(...values);
				container.insertBefore(newEntry.firstElementChild, form);
	
				inputSelectors.forEach(
					(id) => (document.getElementById(id).value = "")
				);
	
				form.classList.add("d-none");
			});
		}
	}
	
	handleAddEntry(
		".skills-list-add-new",
		".form-element--skills",
		["skillName"],
		(skillName) => {
			return `
			<div class="skills-list-item">
                <input type="text" name="skills[]" value="${skillName}">
				<button type="button" class="delete-file"><span class="icon-delete"></span></button>
			</div>`;
		}
	);
	
	// Handle delete functionality
	handleDeleteEntry(".skills-list-item");
	handleDeleteEntry(".drivers-license-wrap");
	handleDeleteEntry(".university-wrap");
	/* --- skills --- */

	/* -- applicant license -- */
	const licenses = [];
	handleAddEntryLicense(
		".form-element--drivers-license-add-new",
		".form-element--drivers-license",
		["licenseName", "licenseNumber", "stateName", "expiryDate"],
		(licenseName, licenseNumber, stateName, expiryDate) => `
			<div class="drivers-license-wrap">
					<div class="drivers-license-wrap-content">
						<span class="license-name">${licenseName}</span>
						<div class="license-number-expiry">
							<span class="license-state" hidden>${stateName}</span>
							<span class="license-number">${licenseNumber}</span>
							<span class="license-expiry">${expiryDate}</span>
						</div>
					</div>
					<div class="btn-wrap">
						<button type="button" class="edit-license"><span class="icon-edit"></span></button>
						<button type="button" class="delete-file"><span class="icon-delete"></span></button>
					</div>
			</div>`
	);

	function handleAddEntryLicense(formSelector, containerSelector, inputSelectors, templateCallback) {
		const form = document.querySelector(formSelector);
		const container = document.querySelector(containerSelector);
		const licenseAddButton = form?.querySelector(".add-btn");

		if (licenseAddButton && container) {
			licenseAddButton.addEventListener("click", function () {
				// Extract and trim input values
				const values = inputSelectors.map((id) => {
					let inputValue = document.getElementById(id)?.value.trim();
					if ((id === "expiryDate" || id === "passedYear") && inputValue) {
						inputValue = inputValue.split("-")[0];
					}
					return inputValue;
				});

				// Validate inputs
				if (values.some((value) => value === "")) {
					alert("Please fill in all required fields.");
					return;
				}

				// Create and insert new entry
				const newEntry = document.createElement("div");
				newEntry.innerHTML = templateCallback(...values);
				const entryElement = newEntry.firstElementChild;
				container.insertBefore(entryElement, form);

				// Handle delete
				const deleteBtn = entryElement.querySelector(".delete-file");
				if (deleteBtn) {
					deleteBtn.addEventListener("click", function () {
						const entryData = entryElement.getAttribute("data-entry");
						const index = licenses.indexOf(entryData);
						if (index !== -1) {
							licenses.splice(index, 1);
						}
						entryElement.remove();
					});
				}

				// Clear form
				inputSelectors.forEach((id) => {
					document.getElementById(id).value = "";
				});

				// Hide form
				form.classList.add("d-none");
			});
		}
	}
	/* --- applicant license --- */

	/* -- applicant qualification -- */
	const qualifications = [];
	handleAddEntryQualification(
		".form-element--qualification-add-new",
		".form-element--qualification",
		["courseName", "universityName", "passedYear"],
		(courseName, universityName, passedYear) => `
			<div class="university-wrap">
			<div class="university-wrap-content">
				<span class="course-name">${courseName}</span>
				<div class="university-name-passed-year">
				<span class="course-place">${universityName}</span>
				<span class="course-year">${passedYear}</span>
				</div>
			</div>
			<div class="btn-wrap">
				<button type="button" class="edit-qualification"><span class="icon-edit"></span></button>
				<button type="button" class="delete-file"><span class="icon-delete"></span></button>
			</div>
			</div>`
	);

	function handleAddEntryQualification(formSelector, containerSelector, inputSelectors, templateCallback) {
		const form = document.querySelector(formSelector);
		const container = document.querySelector(containerSelector);
		const addButton = form?.querySelector(".add-btn");

		if (addButton && container) {
			addButton.addEventListener("click", function () {
			// Get input values
			const values = inputSelectors.map(id => {
				let val = document.getElementById(id)?.value.trim();
				if (id === "passedYear" && val) {
				val = val.split("-")[0];
				}
				return val;
			});

			// Validate
			if (values.some(val => val === "")) {
				alert("Please fill in all fields.");
				return;
			}

			const newEntry = document.createElement("div");
			newEntry.innerHTML = templateCallback(...values);
			const entryEl = newEntry.firstElementChild;

			container.insertBefore(entryEl, form);

			// DELETE handler
			const deleteBtn = entryEl.querySelector(".delete-file");
			deleteBtn.addEventListener("click", function () {
				entryEl.remove();
			});

			// Clear inputs & hide form
			inputSelectors.forEach(id => {
				document.getElementById(id).value = "";
			});
			form.classList.add("d-none");
			});
		}
	}
	/* --- applicant qualification --- */


	// custom year dropdown
	function setupYearDropdown(inputClass, dropdownClass) {
		const yearInputs = document.querySelectorAll(`.${inputClass}`);

		yearInputs.forEach(function (yearInput) {
			const yearDropdown = yearInput.nextElementSibling; // Find the sibling dropdown div
			const currentYear = new Date().getFullYear();

			// Clear any previous year options to avoid duplicates
			yearDropdown.innerHTML = "";

			// Populate the year dropdown (current year to 50 years back)
			for (let i = currentYear + 3; i >= currentYear - 50; i--) {
				let yearOption = document.createElement("div");
				yearOption.textContent = i;
				yearOption.classList.add("dropdown-item");

				// Set a data attribute for easier identification
				yearOption.dataset.year = i;

				// Append the option to the dropdown
				yearDropdown.appendChild(yearOption);
			}

			// Show dropdown when the input is clicked
			yearInput.addEventListener("click", function () {
			yearDropdown.style.display = "block";
			});

			// Event delegation: Listen for clicks on the dropdown
			yearDropdown.addEventListener("click", function (event) {
			const clickedOption = event.target;

			// Ensure we clicked on a dropdown-item
			if (clickedOption.classList.contains("dropdown-item")) {
				const selectedYear = clickedOption.dataset.year; // Get the year from the data attribute

				// Set the selected year value in the input
				yearInput.value = selectedYear;
				yearDropdown.style.display = "none"; // Hide dropdown after selection
			}
			});

			// Restrict input to numbers only
			yearInput.addEventListener("input", function () {
			yearInput.value = yearInput.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
			});
			
			// Hide dropdown when clicking outside
			document.addEventListener("click", function (event) {
			if (
				!yearInput.contains(event.target) &&
				!yearDropdown.contains(event.target)
			) {
				yearDropdown.style.display = "none";
			}
			});
		});
	}

	// Initialize the year dropdowns for both fields using class selectors
	setupYearDropdown("year-input", "year-dropdown");

	/* -- edit qualification -- */
	document.addEventListener("click", function (event) {
		const editButton = event.target.closest(".edit-qualification");
	
		if (editButton) {
			const universityWrap = editButton.closest(".university-wrap");
			const existingForm = document.querySelector(".edit-qualification-form");
			if (existingForm) existingForm.remove();
	
			const addNewForm = document.querySelector(".form-element--qualification-add-new");
			const clonedForm = addNewForm.cloneNode(true);
			clonedForm.classList.remove("d-none");
			clonedForm.classList.add("edit-qualification-form");
	
			const courseEl = universityWrap.querySelector(".course-name");
			const universityEl = universityWrap.querySelector(".course-place");
			const yearEl = universityWrap.querySelector(".course-year");
	
			clonedForm.querySelector("#courseName").value = courseEl.textContent.trim();
			clonedForm.querySelector("#universityName").value = universityEl.textContent.trim();
			clonedForm.querySelector("#passedYear").value = yearEl.textContent.trim();
	
			const cancelButton = document.createElement("button");
			cancelButton.type = "button";
			cancelButton.classList.add("btn", "btn-sm", "btn-delete");
			cancelButton.textContent = "Cancel";
	
			const addButton = clonedForm.querySelector(".add-btn");
			if (!clonedForm.querySelector(".btn-delete")) {
				addButton.insertAdjacentElement("afterend", cancelButton);
			}
	
			universityWrap.after(clonedForm);
			setupYearDropdown("year-input", "year-dropdown");
	
			addButton.addEventListener("click", function () {
				const updatedCourseName = clonedForm.querySelector("#courseName").value.trim();
				const updatedUniversityName = clonedForm.querySelector("#universityName").value.trim();
				const updatedPassedYear = clonedForm.querySelector("#passedYear").value.trim();
	
				if (!updatedCourseName || !updatedUniversityName || !updatedPassedYear) {
					alert("Please fill in all fields.");
					return;
				}
	
				// Update UI
				courseEl.textContent = updatedCourseName;
				universityEl.textContent = updatedUniversityName;
				yearEl.textContent = updatedPassedYear;
	
				// Update data-entry attribute
				// const newEntry = `qualificationName:${updatedCourseName},placeOfCompletion:${updatedUniversityName},yearOfCompletion:${updatedPassedYear}`;
				// universityWrap.setAttribute("data-entry", newEntry);
	
				// Update hidden input
				// const qualificationWraps = document.querySelectorAll(".university-wrap");
				// const allData = Array.from(qualificationWraps).map(el => el.getAttribute("data-entry"));
				// document.querySelector("#applicant_qualification").value = allData.join(";");
	
				// Remove the form
				clonedForm.remove();
			});
	
			cancelButton.addEventListener("click", function () {
				clonedForm.remove();
			});
		}
	});
	/* --- edit qualification --- */

	/* -- edit license -- */
	document.addEventListener("click", function (event) {
		const editButton = event.target.closest(".edit-license");
	
		if (!editButton) return;
	
		const licenseWrap = editButton.closest(".drivers-license-wrap");
		const existingForm = document.querySelector(".edit-license-form");
		if (existingForm) existingForm.remove();
	
		const addNewForm = document.querySelector(".form-element--drivers-license-add-new");
		const clonedForm = addNewForm.cloneNode(true);
		clonedForm.classList.remove("d-none");
		clonedForm.classList.add("edit-license-form");
	
		// Populate fields with existing data
		clonedForm.querySelector("#licenseName").value = licenseWrap.querySelector(".license-name").textContent.trim();
		const spanFields = licenseWrap.querySelectorAll(".license-number-expiry span");
		clonedForm.querySelector("#stateName").value = spanFields[0].textContent.trim();
		clonedForm.querySelector("#licenseNumber").value = spanFields[1].textContent.trim();
		clonedForm.querySelector("#expiryDate").value = spanFields[2].textContent.trim();
	
		// Add cancel button if not already added
		const addButton = clonedForm.querySelector(".add-btn");
		if (!clonedForm.querySelector(".btn-cancel-edit")) {
			const cancelButton = document.createElement("button");
			cancelButton.type = "button";
			cancelButton.className = "btn btn-sm btn-delete btn-cancel-edit";
			cancelButton.textContent = "Cancel";
			addButton.insertAdjacentElement("afterend", cancelButton);
	
			cancelButton.addEventListener("click", () => clonedForm.remove());
		}
	
		licenseWrap.after(clonedForm);
		setupYearDropdown("year-input", "year-dropdown");
	
		// Handle update
		addButton.addEventListener("click", function () {
			const updatedName = clonedForm.querySelector("#licenseName").value.trim();
			const updatedNumber = clonedForm.querySelector("#licenseNumber").value.trim();
			const updatedState = clonedForm.querySelector("#stateName").value.trim();
			const updatedExpiry = clonedForm.querySelector("#expiryDate").value.trim();
	
			if (!updatedName || !updatedNumber || !updatedState || !updatedExpiry) {
				alert("Please fill in all fields.");
				return;
			}
	
			licenseWrap.querySelector(".license-name").textContent = updatedName;
			const updatedSpans = licenseWrap.querySelectorAll(".license-number-expiry span");
			updatedSpans[0].textContent = updatedState;
			updatedSpans[1].textContent = updatedNumber;
			updatedSpans[2].textContent = updatedExpiry;
	
			clonedForm.remove();
			_____updateApplicantLicenseHiddenInput();
		});
	});


	function _____updateApplicantLicenseHiddenInput() {
		const licenseEntries = document.querySelectorAll(".drivers-license-wrap");
		let licenseData = [];
	
		licenseEntries.forEach(entry => {
			const licenseName = entry.querySelector(".license-name").textContent.trim();
			const spanFields = entry.querySelectorAll(".license-number-expiry span");
			const state = spanFields[0].textContent.trim();
			const number = spanFields[1].textContent.trim();
			const expiry = spanFields[2].textContent.trim();
	
			const singleLicense = `licenseName:${licenseName},licenseNo:${number},licenseState:${state},licenseExpiry:${expiry}`;
			licenseData.push(singleLicense);
		});
	
		// document.getElementById("applicant_license").value = licenseData.join(";");
	}
	/* --- edit license --- */
	
});